import { QueryDtoOf } from '@40seas/entities/common';
import { Refund } from './refund.entity';

export class QueryRefundDto extends QueryDtoOf(Refund) {}
